import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import AdminGateway from '~apis/admin';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TEditAdminDetailsReduxParams } from '~types/feat/admin';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchEditAdminDetails(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('admin/adminEditAdminDetailsAttempt', handleEditAdminDetails, api);
}

function* handleEditAdminDetails(api: AdminGateway, data: PayloadAction<TEditAdminDetailsReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.editAdminDetails], {
        authToken,
        ...data.payload,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.adminEditAdminDetailsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.adminGetAdminListingAttempt());
        yield put(combinedActions.adminEditAdminDetailsSuccess());
        yield put(combinedActions.adminSetAdminDetailsModalIsOpen(false));

        toast.success(SuccessMessages.AdminEditAdminDetailsSuccess);
    }
}
